import { z } from 'zod';
import { PREDEFINED_ROLES } from '../app-constants/role.constant';

export enum RoleType {
  external = 'external',
  internal = 'internal',
}

export const RoleSchema = z.object({
  id: z.string(),
  roleKey: z.number(),
  roleName: z.string(),
  roleDescription: z.string().optional(),
  isInternalAdmin: z.boolean().optional(),
  isCsm: z.boolean().optional(),
});

export const RolesSchema = z.array(RoleSchema);
export type Role = z.infer<typeof RoleSchema>;
export type Roles = z.infer<typeof RolesSchema>;

export type PredefinedRoleKey = keyof typeof PREDEFINED_ROLES;

export enum PermissionScopeEnum {
  self = 'self',
  related = 'related',
}

export enum PermissionLevelEnum {
  create = 'create',
  read = 'read',
  update = 'update',
  delete = 'delete',
  execute = 'execute',
  all = 'all',
}

export const ModuleSchema = z.object({
  type: z.string(),
  name: z.string(),
});

export type Module = z.infer<typeof ModuleSchema>;

// Module with permissions schema for admin modules listing
export const ModuleWithPermissionsSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  availability: z.enum(['internal', 'external']).optional(),
  permissions: z
    .array(
      z.object({
        id: z.string(),
        moduleId: z.string().optional(),
        module: ModuleSchema.optional(),
        scope: z.nativeEnum(PermissionScopeEnum),
        permissionLevel: z.nativeEnum(PermissionLevelEnum),
      }),
    )
    .default([]),
});

export type ModuleWithPermissions = z.infer<typeof ModuleWithPermissionsSchema>;

export const PermissionSchema = z.object({
  id: z.string(),
  moduleId: z.string().optional(),
  module: ModuleSchema.optional(),
  scope: z.nativeEnum(PermissionScopeEnum),
  permissionLevel: z.nativeEnum(PermissionLevelEnum),
});

export type Permission = z.infer<typeof PermissionSchema>;

export type AccessPolicy = {
  moduleName: string;
  permission: string;
  scope?: string;
};

export enum AccessPolicyType {
  and = 'and',
  or = 'or',
}

export type AccessPolicies = {
  type: AccessPolicyType;
  policies: AccessPolicy[];
};

export const AssignedUserSchema = z.object({
  userName: z.string().optional(),
  userEmail: z.string().optional(),
  tenantName: z.string().optional(),
});

export type AssignedUser = z.infer<typeof AssignedUserSchema>;
export type AssignedUsers = AssignedUser[];

export const getCustomerUserPermissions = (): Permission[] => {
  return [];
};
